/* eslint-disable no-restricted-globals */
import moment from 'moment';
import { call, put, select } from 'redux-saga/effects';
import {
  updateEarliestDelivery,
  getEarliestDeliveryOptionsFailure,
  getEarliestDeliveryOptionsStarted,
  setShowZipCodeAndCheck,
} from '../../actions/earliestDeliveryAction';
import {
  sendCheckAvailabilityEventToAnalytics,
  resetCart,
} from '../../actions/cartActions/_actionCreators';
import { getEarliestDelivery as getEarliestDeliveryApi } from '../../api/getEarliestDelivery';
import { productInfoSelector, earliestDeliveryInfoSelector } from '../../selectors';
import safeSaga from '../safeSaga';
import { trackErrorInteractions } from '../../utils/analytics/trackEvents';

const getItemIds = (productInfo) => {
  const itemIdArr = [];
  const keys = Object.keys(productInfo);
  keys.forEach((key) => {
    const { itemId } = productInfo[key];
    if (itemId > 0) {
      itemIdArr.push(itemId);
    }
    return itemId;
  });
  return itemIdArr.join(',');
};

const findAvailabilityStatus = (skus) => {
  if (skus?.every((sku) => sku.status === 'AVAILABLE')) {
    return 'AVAILABLE';
  }

  if (skus?.some((sku) => sku.status === 'OOS_ETA_UNAVAILABLE')) {
    return 'OOS_ETA_UNAVAILABLE';
  }

  if (skus?.some((sku) => sku.status === 'BACK_ORDERED')) {
    return 'BACK_ORDERED';
  }

  return 'ERROR';
};

function* earliestDeliveryByZipCode() {
  try {
    const earliestDeliveryInfo = yield select(earliestDeliveryInfoSelector);

    if (
      earliestDeliveryInfo &&
      earliestDeliveryInfo.zipCode &&
      earliestDeliveryInfo.zipCode !== '' &&
      earliestDeliveryInfo.zipCode.length === 5
    ) {
      const productInfo = yield select(productInfoSelector);
      const itemIds = getItemIds(productInfo);
      if (itemIds != null) {
        yield put(getEarliestDeliveryOptionsStarted());
        yield put(setShowZipCodeAndCheck(false));
        yield put(resetCart());
        const data = yield call(getEarliestDeliveryApi, itemIds, earliestDeliveryInfo.zipCode);
        if (data != null && data?.deliveryAvailabilityResponse?.errorData == null) {
          const availability =
            data?.deliveryAvailabilityResponse?.deliveryAvailability?.availability;
          const isError =
            data?.deliveryAvailabilityResponse?.deliveryAvailability?.zipCode === undefined ||
            availability?.some((avail) => avail.status === 'UNAVAILABLE') ||
            availability?.some((avail) => avail.status === 'OOS_ETA_UNAVAILABLE') ||
            availability?.some((avail) => avail.csrStatusCode === '01');
          let earliestDate;
          if (!isError) {
            earliestDate = moment(
              data.deliveryAvailabilityResponse.deliveryAvailability?.earliestAvailabilityDate,
              'YYYY-MM-DD',
              true
            );

            earliestDate = earliestDate?.isValid()
              ? earliestDate.toDate()
              : moment().add(30, 'days');
          }
          yield put(
            updateEarliestDelivery(
              earliestDate,
              isNaN(data?.deliveryAvailabilityResponse?.deliveryAvailability?.zipCode)
                ? ''
                : data?.deliveryAvailabilityResponse?.deliveryAvailability?.zipCode,
              findAvailabilityStatus(availability)
            )
          );

          // if we reach here we have data to process for available and unavailable scenarios
          yield put(sendCheckAvailabilityEventToAnalytics(data));
        } else {
          throw Error();
        }
      }
    }
  } catch (ex) {
    const errorObject = {
      type: 'system',
      displayType: 'page',
      pageSection: 'Earliest Delivery Option',
      message: ex.response.statusText || 'An Internal Error has Occurred',
      code: ex.response.status || 'API did not respond',
    };
    trackErrorInteractions(errorObject, 'error', 'post page error');
    yield put(getEarliestDeliveryOptionsFailure());
  }
}

export default safeSaga(earliestDeliveryByZipCode);
